'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'cloud-rainbow';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f73e';
var svgPathData = 'M330.3 144C385.8 84.9 464.6 48 552 48l24 0 0-48-24 0c-113.7 0-214.7 53.9-279.1 137.4 5.7 3.5 11.1 7.4 16.3 11.6 12.4-3.3 25.4-5 38.8-5 .8 0 1.5 0 2.3 0zm168 109.7C514.2 245 532.5 240 552 240l24 0 0-48-24 0c-34.2 0-65.8 10.7-91.8 28.9 2.8 4.9 5.3 10 7.6 15.3 10.9 4.7 21.1 10.5 30.5 17.5zm-68.1-70.3C464.4 158.6 506.5 144 552 144l24 0 0-48-24 0c-62.7 0-120.2 22.6-164.7 60 15.8 6.7 30.3 16 42.8 27.4zM112 280c0-39.8 32.2-72 72-72 28.9 0 53.9 17.1 65.4 41.8l14.5 31.3 24.3-24.5c10.2-10.3 24.2-16.6 39.8-16.6 30.9 0 56 25.1 56 56l0 24 24 0c30.9 0 56 25.1 56 56l0 56-416 0 0-56c0-27.1 19.2-49.7 44.8-54.9l19.2-3.9 0-37.2zm72-120c-66.3 0-120 53.7-120 120-37.6 15.7-64 52.7-64 96l0 104 512 0 0-104c0-50-35.3-91.7-82.3-101.7-10-47-51.7-82.3-101.7-82.3-18.3 0-35.4 4.7-50.3 13-22-27.4-55.7-45-93.7-45z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCloudRainbow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;